import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  container: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    zIndex: 100,
    backgroundColor: theme.palette.background.paper,

    '& h1': {
      margin: '6px 0 12px',
    },
  },

  content: {
    margin: '121px auto 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: theme.palette.text.primary,
  },
  mainContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',
    textAlign: 'center',
  },
  description: {
    margin: '0 0 30px',
  },
  button: {
    fontSize: 14,
    fontWeight: 700,
    borderRadius: 30,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    padding: '12px 20px',
  },
}));
